// extracted by mini-css-extract-plugin
export default {"root":"eY2Mgmn4Z4B234MsuoIk"};